import actionConstants from '../constants/';

/**
 * UI Filters Persistence Reducer
 * Manages filter state for various screens programmatically without localStorage
 * 
 * Each filter state includes a `basePath` field to scope filters to specific screen hierarchies.
 * Filters should only persist when navigating between parent and child routes (e.g., list → detail → list).
 * When navigating to sibling or unrelated routes, filters should reset.
 */

// Default filter states for different screens
const edgeV3TransactionsFilters = {
  basePath: null, // Track the base route for scoped persistence
  dateRange: null,
  selectedHorizontalFilter: 'Today',
  orderStatus: null,
  listingView: 'transaction',
};

// Filters for TransactionLevelListing child component
const transactionLevelListingFilters = {
  basePath: null,
  sortBy: '',
  orderBy: '',
  page: 1,
  selectedFilterType: '',
  filterSearchValue: '',
  appliedFiltersList: [],
  appliedFilter: null,
  visibleColumns: null,
};

// Filters for OrderLevelListing child component
const orderLevelListingFilters = {
  basePath: null,
  sortBy: '',
  orderBy: '',
  page: 1,
  selectedFilterType: '',
  filterSearchValue: '',
  appliedFiltersList: [],
  appliedFilter: null,
  visibleColumns: null,
};

const updatedSettlementsFilters = {
  basePath: null,
  dateRange: null,
  searchText: '',
  page: 1,
  sortBy: '',
  orderBy: '',
};

const orderDetailsFilters = {
  basePath: null,
};

const initialState = {
  edgeV3Transactions: { ...edgeV3TransactionsFilters },
  transactionLevelListing: { ...transactionLevelListingFilters },
  orderLevelListing: { ...orderLevelListingFilters },
  updatedSettlements: { ...updatedSettlementsFilters },
  orderDetails: { ...orderDetailsFilters },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function uiFiltersReducer(state = initialState, action) {
  switch (action.type) {
    // ─── Edge V3 Transactions Filters ───────────────────────────────────
    case actionConstants.SET_EDGE_V3_TRANSACTIONS_FILTERS:
      return {
        ...state,
        edgeV3Transactions: {
          ...state.edgeV3Transactions,
          ...action.payload,
        },
      };

    case actionConstants.RESET_EDGE_V3_TRANSACTIONS_FILTERS:
      return {
        ...state,
        edgeV3Transactions: { ...edgeV3TransactionsFilters },
      };

    // ─── Transaction Level Listing Filters ─────────────────────────────
    case actionConstants.SET_TRANSACTION_LEVEL_LISTING_FILTERS:
      return {
        ...state,
        transactionLevelListing: {
          ...state.transactionLevelListing,
          ...action.payload,
        },
      };

    case actionConstants.RESET_TRANSACTION_LEVEL_LISTING_FILTERS:
      return {
        ...state,
        transactionLevelListing: { ...transactionLevelListingFilters },
      };

    // ─── Order Level Listing Filters ───────────────────────────────────
    case actionConstants.SET_ORDER_LEVEL_LISTING_FILTERS:
      return {
        ...state,
        orderLevelListing: {
          ...state.orderLevelListing,
          ...action.payload,
        },
      };

    case actionConstants.RESET_ORDER_LEVEL_LISTING_FILTERS:
      return {
        ...state,
        orderLevelListing: { ...orderLevelListingFilters },
      };

    // ─── Updated Settlements Filters ───────────────────────────────────
    case actionConstants.SET_UPDATED_SETTLEMENTS_FILTERS:
      return {
        ...state,
        updatedSettlements: {
          ...state.updatedSettlements,
          ...action.payload,
        },
      };

    case actionConstants.RESET_UPDATED_SETTLEMENTS_FILTERS:
      return {
        ...state,
        updatedSettlements: { ...updatedSettlementsFilters },
      };

    // ─── Order Details Filters ─────────────────────────────────────────
    case actionConstants.SET_ORDER_DETAILS_FILTERS:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          ...action.payload,
        },
      };

    case actionConstants.RESET_ORDER_DETAILS_FILTERS:
      return {
        ...state,
        orderDetails: { ...orderDetailsFilters },
      };

    default:
      return state;
  }
}
